// .envのキーも合わす事
// package.jsonも修正必要

// 本番
export const API_DOMAIN_URL = "https://hacaro2-pro.azurewebsites.net";
export const STORAGE_DOMAIN_URL =
 "https://devseniorquality8937.blob.core.windows.net";
export const PAGE_PATH = "dashboard";

// ローカル
//export const API_DOMAIN_URL = "http://localhost:7071";
//export const STORAGE_DOMAIN_URL = "https://devhacaroa09f.blob.core.windows.net";
//export const PAGE_PATH = "dev-dashboard";

// 開発
//export const API_DOMAIN_URL = "https://dev-hacaro2-pro.azurewebsites.net";
//export const STORAGE_DOMAIN_URL = "https://devhacaroa09f.blob.core.windows.net";
//export const PAGE_PATH = "dev-dashboard";

// ローカル
//export const API_DOMAIN_URL = "http://localhost:7071";
//export const STORAGE_DOMAIN_URL = "http://127.0.0.1:10000/devstoreaccount1";
//export const PAGE_PATH = "dev-dashboard";
